import { Api } from 'utils';

class ProfileService {
	
	static update = async (params?: any) => Api.createResponse('web/admin/profile/update',params);
	static password = async (params?: any) => Api.createResponse('web/admin/profile/password',params);
	static get = async (params?: any) => Api.createResponse('web/admin/profile/get',params);
}

export default ProfileService;